import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { DEFAULT_IMG } from "../../utils/aap-image-constant";
import { useTranslation } from "react-i18next";
import { getSpecializationList } from "../../hooks/services/api-services";
import parse from "html-react-parser";
import { API_URL } from "../../utils/url-constants";

const DoctorsSlider = () => {
  const { t, i18n } = useTranslation();
  const [activeArrow, setActiveArrow] = useState("next");

  const NextArrow = ({ onClick }) => (
    <div
      className={`custom-arrow cursor-pointer rounded-30 d-flex justify-content-center align-items-center  next-arrow ${activeArrow === "next" ? "active" : ""
        }`}
      onClick={() => {
        setActiveArrow("next");
        onClick();
      }}
    >
      ➡
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div
      className={`custom-arrow cursor-pointer rounded-30 d-flex justify-content-center align-items-center  prev-arrow ${activeArrow === "prev" ? "active" : ""
        }`}
      onClick={() => {
        setActiveArrow("prev");
        onClick();
      }}
    >
      ⬅
    </div>
  );
  // API Code to Fetch Specializations
  const [specializationList, setSpecializationList] = useState([]);
  const fetchSpecializations = async (language) => {
    try {
      const response = await getSpecializationList(language);
      if (response?.data?.status === 200) {
        const formattedList = response?.data?.data;
        setSpecializationList(formattedList);
      } else {
        // toastEmitter("error", response?.data?.message);
      }
    } catch (error) {
      // toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    }
  };

  useEffect(() => {
    if (i18n.language) {
      fetchSpecializations(i18n.language);
    }
  }, [i18n.language]);

  // if (!specializationList.length) {
  //   // If no data, don't render the component
  //   return null;
  // }

  const isSingleItem = specializationList.length <= 1;
  const settings = {
    dots: true,
    infinite: !isSingleItem, // only allow infinite scroll if there's more than 1 item
    speed: 500,
    slidesToShow: Math.min(4, specializationList.length), // show max 4 or less if fewer items
    slidesToScroll: Math.min(4, specializationList.length),
    nextArrow: !isSingleItem ? <NextArrow /> : null,
    prevArrow: !isSingleItem ? <PrevArrow /> : null,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: Math.min(3, specializationList.length),
          slidesToScroll: Math.min(3, specializationList.length),
          infinite: specializationList.length > 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: Math.min(2, specializationList.length),
          slidesToScroll: Math.min(2, specializationList.length),
          infinite: specializationList.length > 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
        },
      },
    ],
  };
  return (
    <>
      {specializationList?.length !== 0 &&
        <div className="doctor_slider">
          <div className="d-flex flex-wrap justify-content-between align-items-center my-4">
            <h1 className="mainheading fs-45 fw-600 ">
              {t("Choose Doctor's")}{" "}
              <span className="italic-text  textcolor">{t("Expertise")}</span>
            </h1>
          </div>
          <Slider {...settings}>
            {specializationList && specializationList?.map((specialty, index) => (
              <div key={index} className="px-2">
                <div
                  className="card  px-1 rounded-4"
                  style={{ height: "280px" }}
                >    <div>
                    <img
                      className="card-img-top card-image-height-width"
                      src={
                        specialty?.image && specialty?.image.trim() !== ""
                          ? `${API_URL?.ServerURL}${specialty?.image}`
                          : DEFAULT_IMG
                      }
                      alt={specialty?.specializationName}
                      style={{objectFit:"contain"}}
                    />
                  </div>
                  <div className="card-body text-start">

                    <h5 className="card-title card-specialization fs-22 ">
                      {t(specialty?.specializationName)}
                    </h5>
                    <p
                      className="card-text text-muted fs-12 grayparaColor cursor-pointer"
                      style={{ minHeight: "48px" }}
                      title={specialty?.specializationContent}
                    >
                      {parse(specialty?.specializationContent?.slice(0, 70))}
                      {specialty?.specializationContent?.length > 70 && "..."}
                    </p>

                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      }
    </>
  );
};

export default DoctorsSlider;

